import { Flex, Image, Tab, TabList, Text } from "@chakra-ui/core";
import React from "react";
import { TabBarIcons } from "../../../../../Data/Profile";
import "./style.scss";

function TabBar() {
  return (
    <TabList>
      {TabBarIcons.map((each) => (
        <Tab key={each.title}>
          <Flex direction="column" align="center" padding="5">
            <Image src={each.icon} />
            <Text color="#eeeeee">{each.title}</Text>
          </Flex>
        </Tab>
      ))}
    </TabList>
  );
}

export default TabBar;
